const dataWardens = [
  {
    name: "Prof. Akhilesh Kumar Mishra",
    designation: "Chief Warden",
    img: "chiefWarden.jpg",
    phone: "1332285364",
    email: "akhilesh.mishra@iitr.ac.in",
  },
  {
    name: "Prof. Mohit Prakash Mohanty",
    designation: "Mess Warden",
    img: "Mohit_mess_warden.jpg",
    phone: "+917738705864",
    email: "mohit.mohanty@wr.iitr.ac.in",
  },
  {
    name: "Raju Kumar",
    designation: "Residential Warden",
    img: "warden.jpg",
    phone: "7255040260",
    email: "r_kumar6@me.iitr.ac.in",
  },
  {
    name: "Amit Kumar",
    designation: "Supervisor",
    img: "supervisor.jpg",
    phone: "9456318500",
    email: "ravindrabhawan@iitr.ac.in",
  },
];

const dataSecy = [
  {
    name: "Vasu Mittal",
    designation: "Bhawan Secretary",
    img: "vasu.jpg",
    phone: "+91 90581 02262",
    email: "v_mittal@ce.iitr.ac.in",
  },
  {
    name: "Yash Mehra",
    designation: "Social and Cultural Secretary",
    img: "Yash.png",
    phone: "+91 9953066851",
    email: "Y_mehra@bt.iitr.ac.in",
  },
  {
    name: "Savinyu Pant",
    designation: "Sports Secretary",
    img: "savinyu.jpg",
    phone: "+91 70657 10598",
    email: "s_pant@bt.iitr.ac.in",
  },
  {
    name: "Naman Kapoor",
    designation: "Wellness Secretary",
    img: "naman.jpg",
    phone: "+91 76968 30140",
    email: "n_kapoor@ph.iitr.ac.in",
  },
  {
    name: "Jatin Handa",
    designation: "Technical Secretary",
    img: "Handa.jpg",
    phone: "+91 63970 43465",
    email: "j_handa@me.iitr.ac.in",
  },
  {
    name: "Ayush Bhaskar",
    designation: "Maintenance secretary",
    img: "ayush.jpg",
    phone: "+91 9893316458",
    email: "a_bhaskar@ce.iitr.ac.in",
  },
  {
    name: "Aditya kaushik ",
    designation: "Mess secretary",
    img: "aditya.jpg",
    phone: "+91 8936811594",
    email: "a_kaushik@me.iitr.ac.in",
  },
];

export default dataWardens;
export { dataSecy };
